import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import './ASetting.css';
import validator from 'validator';
import axios from 'axios';
import { apilink } from '../../data/fdata';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import SideBar from '../../component/sidebar/SideBar';

const ASetting = () => {
  const hecord_tokon = Cookies.get('_hecord_access_user_tokon_');
  const [status, setStatus] = useState(false);
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const his = useHistory();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [dob, setDob] = useState('');
  const [phone, setPhone] = useState('');
  const [bloodg, setBloodG] = useState('');
  const [country, setCountry] = useState('');
  const [pin, setPin] = useState('');
  const [street, setStreet] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const invalidBlood = (bl) => {
    let bloodType = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
    if (!bloodType.includes(bl.toUpperCase())) {
      return false;
    }
    return true;
  };

  const isValidPhoneNumber = (phoneno) => {
    let isValidNumber = false;
    let reg = /^(\d)(?!\1+$)\d*$/;
    let regg = /^\d{10}$/;
    // console.log(phoneno.substring(0, 9));

    let invalidarr = ['0', '1', '2', '3', '4', '5'];

    if (invalidarr.includes(phoneno.substring(0, 1))) {
      return false;
    }
    if (
      validator.isMobilePhone(phoneno) &&
      phone.match(reg) &&
      phone.match(regg)
    ) {
      isValidNumber = true;
    }

    return isValidNumber;
  };

  const onsub = (e) => {
    e.preventDefault();
    let isValidPhNumber = isValidPhoneNumber(phone);
    let isValidBlood = invalidBlood(bloodg);
    if (!isValidPhNumber) {
      setStatus(true);
      setMsg('Invalid Phone Number');
    }
    if (!isValidBlood) {
      setStatus(true);
      setMsg('Invalid Blood Group');
    }
  };

  useEffect(async () => {
    const res = await axios.get(`${apilink}/auth/isVerify`, {
      headers: {
        Authorization: hecord_tokon,
      },
    });
    // console.log(res.data);
    if (!res.data.success) {
      his.push('/');
    }
  }, []);

  return (
    <>
      <div className="whole__page">
        <div className="left_side_navbar">
          <SideBar />
        </div>
        <div className="main_div ">
          <div className="main_inner_div">
            <div className="class_center_80">
              <div className="container">
                <div className="row">
                  <div className="col-12 mx-auto">
                    <div className="card p-3 blob_box">
                      <h5 className="text_blue mb-4">Update Details</h5>

                      {status ? (
                        <>
                          <div class="alert alert-warning alert-dismissible">
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              onClick={() => setStatus(false)}
                            >
                              &times;
                            </button>
                            {msg}
                          </div>
                        </>
                      ) : null}
                      <form action="" onSubmit={onsub}>
                        <div class="form-row">
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="text"
                              class="form-control"
                              name="name"
                              placeholder="Enter Name"
                              required
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                          </div>
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="email"
                              class="form-control"
                              name="email"
                              value={email}
                              placeholder="Enter Email"
                              onChange={(e) => setEmail(e.target.value)}
                              required
                              // readOnly
                            />
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="tel"
                              class="form-control"
                              name="number"
                              value={phone}
                              maxLength={10}
                              placeholder="Enter Number"
                              onChange={(e) => setPhone(e.target.value)}
                              required
                            />
                          </div>
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="text"
                              class="form-control"
                              name="dob"
                              onFocus={(e) => (e.target.type = 'date')}
                              onBlur={(e) => (e.target.type = 'text')}
                              placeholder="Enter DOB"
                              value={dob}
                              onChange={(e) => setDob(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="text"
                              class="form-control"
                              name="blood"
                              value={bloodg}
                              placeholder="Enter Blood Group"
                              onChange={(e) => setBloodG(e.target.value)}
                              required
                            />
                          </div>
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="text"
                              class="form-control"
                              name="street"
                              placeholder="Enter Street"
                              value={street}
                              onChange={(e) => setStreet(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="text"
                              class="form-control"
                              name="city"
                              value={city}
                              placeholder="Enter City"
                              onChange={(e) => setCity(e.target.value)}
                              required
                            />
                          </div>
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="text"
                              class="form-control"
                              name="state"
                              value={state}
                              placeholder="Enter State"
                              onChange={(e) => setState(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="text"
                              class="form-control"
                              name="country"
                              value={country}
                              placeholder="Enter Country"
                              onChange={(e) => setCountry(e.target.value)}
                              required
                            />
                          </div>
                          <div class="form-group col-lg-6 col-md-6">
                            <input
                              type="number"
                              class="form-control"
                              placeholder="Enter Pincode"
                              name="pin"
                              value={pin}
                              onChange={(e) => setPin(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            className={
                              loading
                                ? 'dis btn btn-primary'
                                : 'btn btn-primary'
                            }
                            disabled={loading}
                          >
                            Update Profile
                          </button>
                          {loading && (
                            <div className="text-center p-2">
                              <CircularProgress color="success" size={35} />
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ASetting;
